/// <amd-module name="Repos/ChangesCommon/ChangesContext" />
import * as React from "react";
import { IChangesFilesService, IChangesNavigationService, IChangesViewService } from "./Contracts";

export interface IChangesContext<TVersionDescriptor = {}> {
    /**
     * Service to deal with the files in the changes view.
     */
    filesService: IChangesFilesService<TVersionDescriptor>;

    /**
     * Service to manage diff navigation between the changes of the changes view.
     */
    navigationService: IChangesNavigationService<TVersionDescriptor>;

    /**
     * Service about the overall view of the changes.
     */
    viewService?: IChangesViewService;
}

/**
 * Context provided to highest level changes view so that it can interact with various services
 * to deal with differnet aspects of change management like getting file content, getting file diff, setting
 * view type (inline, side-by-side) etc.
 */
export const ChangesContext = React.createContext<IChangesContext>({} as IChangesContext);

/**
 * Custom hook to use the file changes context in functional components
 */
export function useChangesContext<TVersionDescriptor>(): IChangesContext<TVersionDescriptor> {
    return React.useContext(ChangesContext) as IChangesContext<TVersionDescriptor>;
}
